import { useEffect, useState, useRef } from "react";
import Modal from "../../atom/modal";
import { useNavigate } from "react-router-dom";
import {
  getAppServerTenants,
  getTollFreeNumbers,
  handleDidPurchase,
} from "../../services/api";
import Notification from "../../atom/Notification";
import Table from "../../atom/table";
import { TableSortIconDownArrow } from "../../utils/icons/defaultIcons";
import ThemedButton from "../../atom/ThemedButton/themedButton";
import * as loaderLottie from "../../utils/lottie/loaderLottie.json";
import Lottiefy from "../../atom/lottie/lottie";
import SearchBar from "../../atom/search";
import FadeIn from "react-fade-in";
import { addChildrensToMapData } from "../../services/utilities";
import ComponentMap from "../../atom/componentmap";
import AssignServiceModal from "../provision/edit/modals/assignServiceModal";
import AssignServiceDidModal from "./assignServiceDidModal";
import { log } from "console";

function TollFreeModal(props: any) {
  const { setTollFreeModal } = props;
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [tollFreeNumbers, setTollFreeNumbers] = useState<any>([]);
  const [searchtext, setSearchText] = useState<string>("");
  const [handleKeyPress, setHandleKeyPress] = useState<boolean>(true);
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const [tenantListModal, setTenantListModal] = useState<boolean>(false);
  const [showTenants, setShowTenants] = useState<boolean>(false);
  const [assignServiceModal, setAssignServiceModal] = useState<boolean>(false);
  const [buttonLoader, setButtonLoader] = useState<boolean>(false);

  const dropdownRef = useRef<HTMLDivElement>(null);

  const patterns = ["8**", "83*", "84*", "85*", "86*", "87*", "88*", "80*"];

  const [tableTitles, setTableTitles] = useState<any>([
    {
      key: "did",
      title: "Number",
      icon: <TableSortIconDownArrow />,
      // sort: { direction: "asc", active: true },
    },
    {
      key: "carrier",
      title: "Carrier",
      icon: <TableSortIconDownArrow />,
      // sort: { direction: "asc", active: false },
    },
    {
      key: "",
      type: "checkbox",
      classname: "float-right ",
      selectAll: true,
    },
  ]);

  const [tenantList, setTenantList] = useState<any>([
    {
      title: "Select a tenant",
      name: "displayname",
      value: "",
      type: "multiselectdropdown",
      displayProps: {
        label: "displayname",
        value: "displayname",
      },
      childrens: [],
      required: false,
      errormessage: "Select a tenant",
    },
  ]);

  const [serviceDropdown, setServiceDropdown] = useState<any>([
    {
      title: "Assign Service",
      name: "assigned_to",
      value: "",
      type: "dropdown",
      displayProps: { label: "label", value: "value" },
      childrens: [
        { label: "Unassign", value: "Unassign" },
        { label: "Silhouette", value: "Silhouette" },
      ],
    },
  ]);

  const handleClose = () => {
    if (setTollFreeModal) {
      setTollFreeModal(false);
    } else {
      navigate(-1);
    }
  };

  const fetchTollFreeNumbers = (query: string) => {
    setLoading(true);
    getTollFreeNumbers(query)
      .then((result: any) => {
        setLoading(false);
        if (!result?.success) {
          // Notification...
          Notification(
            "Failed",
            `${result?.message ? result?.message : "Oops! Something went wrong"}`,
            "danger",
          );
          setTollFreeNumbers([]);
        } else {
          setTollFreeNumbers(result?.data?.items || []);
        }
        console.log(result);
      })
      .catch(() => {
        setLoading(false);
        setTollFreeNumbers([]);
      });
  };

  const selectCheckbox = (action: any, data: any) => {
    const clone = [...tollFreeNumbers];
    const title = [...tableTitles];
    if (data?.selectAll === true) {
      const result: any = title.find((node: any) => node.key === data.key);
      result.checked = !result?.checked || false;
      clone.forEach((node: any) => {
        node.checked = result?.checked;
      });
    } else {
      const result = clone.find((node: any) => node.did === data.did);
      if (result) {
        result.checked = !result?.checked || false;
      }
      // Sync the "Select All" checkbox based on whether all items are checked
      const selectAllEntry = title.find((node: any) => node.selectAll === true);
      if (selectAllEntry) {
        selectAllEntry.checked = clone.every((node: any) => node.checked);
      }
    }
    setTableTitles(title);
    setTollFreeNumbers(clone);
  };

  const onHandlePurchase = () => {
    // const selectedNumbers = tollFreeNumbers.filter((n: any) => n.checked);
    // console.log("Selected Toll Free Numbers for Purchase:", selectedNumbers);
    // // Implement purchase logic here, e.g., navigate to a purchase page or open another modal
    // Notification(
    //   "Success",
    //   `You have selected ${selectedNumbers.length} toll free number(s) for purchase.`,
    //   "success",
    // );
  };

  const onHandleAssignTenant = (data?: any) => {
    if (data?.displayname === "" || data?.displayname === null) {
      Notification("Failed", `Select a Tenant`, "danger");
      return;
    } else {
      setAssignServiceModal(true);
    }
  };

  const actionHandler = (action: string, data: any, index: number) => {
    const actionsMap: any = {
      selectall: selectCheckbox,
      change: selectCheckbox,
    };
    const act = actionsMap[action];
    if (act) {
      act(action, data);
    }
  };

  const handleSearch = (data: string) => {
    setShowDropdown(false);

    let query = data.trim();
    if (query !== "") {
      if (query.length === 1) query += "**";
      else if (query.length === 2) query += "*";
      else if (query.length > 3) query = query.substring(0, 3);

      setSearchText(query);
      fetchTollFreeNumbers(query);
    } else {
      setSearchText(data);
      setTollFreeNumbers([]);
    }
  };

  const fetchTenantsList = () => {
    getAppServerTenants("").then((result: any) => {
      console.log("result", result);
      if (!result.success) {
        Notification(
          "Failed",
          `${result?.message ? result?.message : "Oops! Something went wrong"}`,
          "danger",
        );
      } else {
        setTenantList(
          addChildrensToMapData([...tenantList], result?.data, "displayname"),
        );
      }
    });
  };

  const onHandleCancel = () => {
    setShowTenants(false);
    setTenantList((prev: any) =>
      prev.map((item: any) => ({ ...item, value: "" })),
    );
  };

  const onHandleCloseServiceModal = () => {
    setAssignServiceModal(false);
    setServiceDropdown((prev: any) =>
      prev.map((item: any) => ({ ...item, value: "" })),
    );
  };

  const onHandleCompletePurchase = (data: any) => {
    if (data?.assigned_to === "") {
      Notification("Failed", `Select any service`, "danger");
      return;
    }
    setButtonLoader(true);
    const selectedNumbers = tollFreeNumbers
      .filter((n: any) => n.checked)
      .map((n: any) => ({ did: n.did, carrier: n.carrier }));

    let payload: any = {
      numbers: selectedNumbers,
    };
    if (data !== null) {
      payload.tenant_id = tenantList[0]?.value.uuid;
    }
    if (data?.assigned_to === "Silhouette") {
      payload.assigned_to = data?.assigned_to;
    }

    handleDidPurchase(payload).then((result: any) => {
      if (!result?.success) {
        Notification(
          "Failed",
          `${result?.message ? result?.message : "Oops! Something went wrong"}`,
          "danger",
        );
        setButtonLoader(false);
      } else {
        Notification(
          "Success",
          "Toll Free Number(s) purchased successfully",
          "success",
        );
        setShowTenants(false);
        // setTollFreeNumbers([]);
        setButtonLoader(false);
        setTenantListModal(false);
        setAssignServiceModal(false);
        setTollFreeModal(false);
      }
    });
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div>
      <Modal title={"Purchase Toll Free Numbers"} closeEvent={handleClose}>
        <div className="md:w-[700px] min-h-[600px] flex flex-col p-2">
          <div
            className="flex justify-end mb-4 relative z-50"
            ref={dropdownRef}
          >
            <div className="w-[300px]" onClick={() => setShowDropdown(true)}>
              <SearchBar
                placeholder={"Search (e.g. 8**)"}
                searchtext={searchtext}
                setSearchText={setSearchText}
                maxLength={3}
                replaceRegex={/[^0-9*]/g}
                onChangeText={(val: string) => {
                  setSearchText(val);
                  setShowDropdown(true);
                }}
                handleSearch={handleSearch}
                handleKeyPress={handleKeyPress}
                setHandleKeyPress={setHandleKeyPress}
              />
            </div>
            {showDropdown && (
              <div className="absolute top-[52px] right-0 w-[300px] z-[500] bg-[white] border border-[#aaa] shadow-lg rounded-md py-1 max-h-48 overflow-y-auto">
                {patterns
                  .filter((p) => p.includes(searchtext.trim()))
                  .map((p) => (
                    <div
                      key={p}
                      className="px-4 py-2 hover:bg-ternary cursor-pointer text-md"
                      onClick={() => {
                        setSearchText(p);
                        setShowDropdown(false);
                        fetchTollFreeNumbers(p);
                      }}
                    >
                      {p}
                    </div>
                  ))}
                {patterns.filter((p) => p.includes(searchtext.trim()))
                  .length === 0 && (
                  <div className="px-4 py-2 text-sm text-[gray]">
                    Press Enter to search for "{searchtext}"
                  </div>
                )}
              </div>
            )}
          </div>

          <div className="flex-1 relative z-0">
            <Table
              tableTitles={tableTitles}
              tableData={loading ? [] : tollFreeNumbers}
              setTableData={setTollFreeNumbers}
              setTableTitles={setTableTitles}
              button={true}
              buttonIndex={4}
              buttonText1={"manage"}
              width={"w-auto overflow-auto"}
              scrollHeight={"h-[600px] overflow-y-auto relative"}
              permission={"provision.users.put"}
              actions={true}
              actionHandler={actionHandler}
              resultNotFound={!loading && tollFreeNumbers.length === 0}
            />

            {loading && (
              <div className="absolute inset-x-0 top-[40px] bottom-0 z-10 flex justify-center items-center bg-white/70">
                <Lottiefy
                  loop={true}
                  json={loaderLottie}
                  height={60}
                  width={60}
                />
              </div>
            )}
          </div>

          <div className="flex justify-end gap-2 pt-6 pb-2 mt-auto">
            <ThemedButton
              children={"Cancel"}
              theme="secondary"
              click={handleClose}
            />
            <ThemedButton
              children={"Purchase"}
              theme="primary"
              disabled={
                loading ||
                tollFreeNumbers.length === 0 ||
                !tollFreeNumbers.some((n: any) => n.checked)
              }
              click={() => setTenantListModal(true)}
            />
          </div>
        </div>
      </Modal>

      {tenantListModal && (
        <Modal
          title="Select Tenant"
          onClose={() => setTenantListModal(false)}
          closeEvent={() => setTenantListModal(false)}
        >
          <div className="md:w-[500px] p-2">
            <FadeIn>
              <p>Do you want to assign the selected DIDs to a tenant?</p>
              <div className="text-right w-full mt-8 ">
                <ThemedButton
                  children={"No, Continue"}
                  icon="custom"
                  theme="secondary"
                  loading={buttonLoader}
                  click={() => {
                    onHandleCompletePurchase(null);
                  }}
                />
                <ThemedButton
                  children={"Yes, Select Tenant"}
                  icon="custom"
                  theme="primary"
                  // loading={buttonLoader}
                  click={() => {
                    setShowTenants(true);
                    fetchTenantsList();
                  }}
                />
              </div>
            </FadeIn>
          </div>
        </Modal>
      )}

      {showTenants && (
        <Modal
          title="Select Tenant"
          onClose={() => setShowTenants(false)}
          closeEvent={() => setShowTenants(false)}
        >
          <div className="md:w-[500px] p-2">
            <FadeIn>
              <ComponentMap data={tenantList} setData={setTenantList} />

              <div className=" h-full py-4 flex  mt-4 float-right">
                <ThemedButton
                  children={"Cancel"}
                  icon="custom"
                  theme="secondary"
                  // valiData={callReport}
                  // change={setCallReport}
                  click={() => {
                    onHandleCancel();
                  }}
                />
                <ThemedButton
                  children={"Assign & Continue"}
                  icon="custom"
                  theme="primary"
                  click={onHandleAssignTenant}
                  valiData={tenantList}
                  change={setTenantList}
                  // loading={buttonLoader}
                />
              </div>
            </FadeIn>
          </div>
        </Modal>
      )}

      {assignServiceModal && (
        <Modal
          title="Assign Service"
          onClose={() => onHandleCloseServiceModal}
          closeEvent={() => onHandleCloseServiceModal()}
        >
          <div className="md:w-[500px] p-2">
            <FadeIn>
              <ComponentMap
                data={serviceDropdown}
                setData={setServiceDropdown}
              />

              <div className=" h-full py-4 flex  mt-4 float-right">
                <ThemedButton
                  children={"Cancel"}
                  icon="custom"
                  theme="secondary"
                  // valiData={callReport}
                  // change={setCallReport}
                  click={() => {
                    onHandleCloseServiceModal();
                  }}
                />
                <ThemedButton
                  children={"Assign & Purchase"}
                  icon="custom"
                  theme="primary"
                  click={onHandleCompletePurchase}
                  valiData={serviceDropdown}
                  change={setServiceDropdown}
                  loading={buttonLoader}
                />
              </div>
            </FadeIn>
          </div>
        </Modal>
      )}
    </div>
  );
}
export default TollFreeModal;
